// extracted by mini-css-extract-plugin
export default {"input":"ApprovalRuleHeader_input__5jSk0"};